import { gql, TypedDocumentNode } from '@apollo/client';
import { DefaultApiResponse, DefaultArg } from '@libs/graphql';

export type GetFavoriteMarketplaceAssetsCountResponse = {
  getFavoriteMarketplaceAssetsCount: DefaultApiResponse<number>;
};

export const getFavoriteMarketplaceAssetsCountQuery: TypedDocumentNode<
  GetFavoriteMarketplaceAssetsCountResponse,
  DefaultArg
> = gql`
  query Query {
    getFavoriteMarketplaceAssetsCount
  }
`;
